<template>
  <div>
    <nav-header></nav-header>
    <div class="usermanage-form p-l-50 p-r-50 p-t-10 p-b-80">
      <section class="page-content">
        <div class="page-title">
            <h2>Gestão de Usuários</h2>
        </div>
        <hr/>
        <b-container id="buscaUser" fluid>
          <b-row style="margin-bottom: 10px;">
            <b-col lg="6" class="my-1">
              <b-form-group
                label="Filtro"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="text"
                    v-on:input="searchUsers"
                    placeholder="Digite para buscar"
                    autocomplete="off"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button style="marginTop: 0px" :disabled="!filter" @click="filter = '';getUsers()"
                      >Limpar</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="my-1">
              <b-form-group
                v-model="sortDirection"
                label="Filtros Ligados"
                description="Deixe tudo desmarcado para filtrar todos os dados"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-form-checkbox-group
                  v-model="filterOn"
                  :aria-describedby="ariaDescribedby"
                  class="mt-1"
                >
                  <b-form-checkbox value="nome_usuario">Nome</b-form-checkbox>
                  <b-form-checkbox value="email_usuario">Email</b-form-checkbox>
                  <b-form-checkbox v-if="getRole() == 'ADMIN_CEPE'" value="nome_empresa">Empresa</b-form-checkbox>
                  <b-form-checkbox value="desc_permissao">Permissão</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
            :ref="tableId"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            stacked="md"
            show-empty
            small
            @filtered="onFiltered"
            busy.sync="isBusy"
            style="text-align: center;"
          >
            <template #cell(Ativo)="row">
              <b-badge class="badge-status" v-if="row.item.Ativo == 'Sim'" variant="success">Ativo</b-badge>
              <b-badge class="badge-status" v-else-if="row.item.Ativo" variant="danger">Desativo</b-badge>
            </template>
            <template v-if="!isBusy" #cell(actions)="row">
              <b-button-group>
                <b-button
                  size="sm"
                  @click="info(row.item, $event.target)"
                  class="mr-1 my-1 btn btn-primary"
                  v-b-tooltip.hover title="detalhar"
                >
                  <b-icon-search font-scale=".8" style="vertical-align: text-top;"/>
                </b-button>
                <b-button
                  size="sm"
                  variant="dark"
                  @click="$router.push({name: 'editUser', params: {id: row.item['Id']}})"
                  class="mr-1 my-1 btn btn-primary"
                  v-b-tooltip.hover title="alterar"
                >
                  <b-icon-pencil-fill font-scale=".8" style="vertical-align: text-top;" />
                </b-button>
                <b-button
                  v-if="row.item['Ativo'] == 'Sim'"
                  size="sm"
                  @click="active(row.item, $event.target)"
                  class="my-1 btn btn-primary"
                  v-b-tooltip.hover title="desativar"
                >
                  <b-icon-x />
                </b-button>
                <b-button
                  v-else
                  size="sm"
                  @click="active(row.item, $event.target)"
                  class="my-1 btn btn-primary"
                  v-b-tooltip.hover title="ativar"
                >
                  <b-icon-check />
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <b-spinner v-if="isBusy" variant="danger" type="grow" label="Spinning"></b-spinner>

          <!-- Info modal -->
          <b-modal
            :id="infoModal.id"
            :title="infoModal.title"
            ok-only
            @hide="resetInfoModal"
          >
            <p><strong>Nome:</strong> {{ infoModal.content["Nome"] }}</p>
            <p><strong>Email:</strong> {{ infoModal.content["Email"] }}</p>
            <p v-if="this.getRole() == 'ADMIN_CEPE'"><strong>Empresa:</strong> {{ infoModal.content["Empresa"] }}</p>
            <p><strong>Permissão:</strong> {{ infoModal.content["Permissão"] }}</p>
            <p><strong>Último Login:</strong> {{ parseDate(infoModal.content["Último Login"]) || 'Não executou login' }}</p>
            <p><strong>Última Atualização:</strong> {{ parseDate(infoModal.content["Última Atualização"]) }}</p>
            <p><strong>Status:</strong> {{ infoModal.content["Ativo"] == 'Sim' ? 'Ativo' : 'Desativo' }}</p>
          </b-modal>

          <b-modal
            :ref="activeModal.id"
            :id="activeModal.id"
            :title="activeModal.title"
            @hide="resetActiveModal"
            hide-footer
          >
            <p>Deseja <strong>{{activeModal.content["Ativo"] == "Sim" ? "desativar" : "ativar"}}</strong> o usuário {{activeModal.content["Nome"]}} ?</p>
            <b-button @click="$refs[activeModal.id].hide()">Cancelar</b-button>
            <b-button class="btn btn-primary m-r-10" @click="activeUser">{{activeModal.content["Ativo"] == "Sim" ? "Desativar" : "Ativar"}}</b-button>
          </b-modal>
          
        </b-container>
        <div>
          <b-input-group style="justify-content: right">
            <template #prepend>
              <b-input-group-text style="height: 70%; background: transparent">
                Por Página
              </b-input-group-text>
            </template>
            <div>
              <b-form-select
                id="per-page-select"
                class="no-shadow"
                v-model="perPage"
                :options="pageOptions"
              />
            </div>
            <template #append>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                first-number
                last-number
              />
            </template>
          </b-input-group>
        </div>
      </section>
    </div>
    <user-profile-footer></user-profile-footer>
  </div>
</template>

<style scoped>
  .b-table[aria-busy="true"] + .table-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10; /* make sure spinner is over table */
  }
  .badge-status {
    border-radius: 0;
  }
  .spinner-grow {
    position: relative;
    top: 50%;
    left: 50%;
  }
  .no-shadow {
    border-radius: 0;
  }
  .no-shadow:focus, :active {
    border-color: lightgray;
    box-shadow: none !important;
  }
</style>

<style scoped src="@/assets/css/util.css">
</style>

<script>
import axios from "axios";
import NavHeader from "../components/NavHeader.vue";
import UserProfileFooter from "../components/UserProfileFooter.vue";
import config from "../helpers/generalConfig";
import { BPagination, BTable, BSpinner, BBadge } from "bootstrap-vue";

export default {
  components: {
    UserProfileFooter,
    NavHeader,
    BPagination,
    BTable,
    BSpinner,
    BBadge
  },
  data() {
    return {
      isBusy: true,
      items: [{
        Nome: "",
        Email: "",
        "Último Login": "",
        "Última Atualização": "",
        Ativo: "",
        Empresa: "",
        "Permissão": "",
        Id: ""
      }],
      fields: [
        { key: "Nome", label: "Nome", sortable: true },
        { key: "Email", label: "Email", sortable: true },
        ...(this.getRole() == 'ADMIN_CEPE' ? [{ key: "Empresa", label: "Empresa", sortable: true},] : []),
        { key: "Permissão", label: "Permissão", sortable: true},
        {
          key: "Ativo",
          label: "Status",
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: "actions", label: "Ações" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: "Mostrar todos" }],
      sortBy: "Empresa",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      activeModal: {
        id: "active-modal",
        title: "",
        content: "",
      },
      tableId: "table"
    };
  },
  created() {
    this.getUsers();
  },
  computed: {
    rows() {
      return this.items.length;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  watch: {
    filterOn: function () {
      this.searchUsers();
    }
  },
  methods: {
    getUsers() {
      const token = this.$store.getters['auth/token'].token;
      const role = this.$store.getters['auth/user'].Role;
      const id_empresa = this.$store.getters['auth/user'].CompanyId;
      let req = [];
      if (role === 'ADMIN_EMPRESA') {
        req = [
          `${config.jsonServer}/user/company/?id_empresa=${id_empresa}`,
          { headers: { Authorization: "Bearer " + token } }
        ];
      } else {
        req = [
          `${config.jsonServer}/user/`,
          { headers: { Authorization: "Bearer " + token } }
        ];
      }
      axios
        .get(...req)
        .then((res) => {
          this.items = res.data.map((user) => {
            this.isBusy = false;
            return {
              Nome: user.nome_usuario,
              Email: user.email_usuario,
              "Último Login": user.ultimo_login,
              "Última Atualização": user.ultima_atualizacao,
              Ativo: user.ativo == "S" ? "Sim" : "Não",
              "Permissão": user.desc_permissao,
              Id: user.id_usuario,
              Empresa: user.nome_empresa
            };
          });
          this.totalRows = this.items.length;
        })
        .catch((err) => {
          this.$bvToast.toast(err.response ? err.response.data.message : "Sem resposta", {
            title: "Erro na busca de usuários",
            variant: "danger",
            solid: true,
          });
        });
    },
    info(item, button) {
      this.infoModal.title = "Informações Detalhadas";
      this.infoModal.content = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    active(item, button) {
      this.activeModal.title = "Ativação de usuário";
      this.activeModal.content = item;
      this.$root.$emit("bv::show::modal", this.activeModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    resetActiveModal() {
      this.activeModal.title = "";
      this.activeModal.content = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    parseDate(dateString) {
      if(!dateString) return '';
      const months = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul","Ago","Set","Out","Nov","Dez"];
      const date = new Date(dateString);
      return ((date.getDate() + " " + months[(date.getMonth())] + " " + date.getFullYear()));
    },
    activeUser() {
      const token = this.$store.getters["auth/token"].token;
      axios
        .put(`${config.jsonServer}/user/update`, {
          id_usuario: this.activeModal.content['Id'],
          ativo: this.activeModal.content['Ativo'] == 'Sim'? 'N' : 'S' 
        }, {
          headers: {
            Authorization: "Bearer " + token,
          },
        }).then(res => {
          this.$bvToast.toast(
            `Usuário ${this.activeModal.content["Nome"]} foi ${this.activeModal.content["Ativo"] == "Sim"? "desativado" : "ativado"} com sucesso`, 
            {
              title: `${this.activeModal.content["Ativo"] == "Sim"? "Desativação" : "Ativação"} realizada`,
              variant: 'success',
              solid: true
            }
          );
          const ref = this.items.filter(user => user.Email == this.activeModal.content.Email);
          Object.assign(ref[0], {
              Nome: res.data.nome_usuario,
              Email: res.data.email_usuario,
              "Último Login": res.data.ultimo_login,
              "Última Atualização": res.data.ultima_atualizacao,
              Ativo: res.data.ativo == "S" ? "Sim" : "Não",
              "Permissão": res.data.desc_permissao,
              Empresa: this.activeModal.content['Empresa'],
              Id: res.data.id_usuario
          });
          this.$refs['table'].refresh();
          this.$refs[this.activeModal.id].hide();
        })
        .catch(err => {
          this.$bvToast.toast(
            `Erro ao ${this.activeModal.content["Ativo"] == "Sim"? "desativar" : "ativar"} o usuário ${this.activeModal.content["Nome"]}. 
            ${err.response ? err.response.data.message : "Sem resposta do servidor"}`, 
            {
              title: `${this.activeModal.content["Ativo"] == "Sim"? "desativação" : "Ativação"} não realizada.`,
              variant: 'danger',
              solid: true
            }
          );
        });
    },
    searchUsers() {
      if(this.filter){
        let query = '';
        if(this.filterOn.length < 1){
          query = `nome_usuario=${this.filter}&email_usuario=${this.filter}&desc_permissao=${this.filter}&nome_empresa=${this.filter}`;
        }else{
          query = this.filterOn.map(f => `${f}=${this.filter}`).join('&');
        }
        axios
          .get(`${config.jsonServer}/user/search?${query}`, {
            headers: {
              Authorization: "Bearer " + this.$store.getters['auth/token'].token,
            },
          }).then(res => {
            this.items = res.data.map((user) => {
              this.isBusy = false;
              return {
                Nome: user.nome_usuario,
                Email: user.email_usuario,
                "Último Login": user.ultimo_login,
                "Última Atualização": user.ultima_atualizacao,
                Ativo: user.ativo == "S" ? "Sim" : "Não",
                "Permissão": user.desc_permissao,
                Empresa: user.nome_empresa,
                Id: user.id_usuario
              };
            });
            this.totalRows = this.items.length;
          }).catch((err) => {
            this.$bvToast.toast(err.response ? err.response.data.message : "Sem resposta", {
              title: "Erro na busca de usuários",
              variant: "danger",
              solid: true,
            });
          });
      }else{
        this.getUsers();
      }
    },
    getRole() {
      return this.$store.getters['auth/user'].Role;
    }
  },
};
</script>